import { useMemo } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { useCurrency } from '../context/CurrencyContext';
import { useDynamicBanners } from './useDynamicBanners';
import { PublicPurchaseMotionCTAWrapper } from '../components/PublicPurchaseMotionCTAWrapper';
import { isPublicPurchaseMotion } from 'purchase-motions-components/utils/purchaseMotionTypeGuards';
import { TRACKING_SOURCES } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_BANNERS = [];
function buildCTA(banner, screen, currencyCode) {
  var _banner$productApiNam;
  const {
    cta
  } = banner;
  if (!cta) return undefined;
  const ctaCopy = typeof cta.copy === 'string' ? cta.copy : undefined;
  if (typeof cta.url === 'string') {
    const url = cta.url;
    return /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      size: "small",
      onClick: () => {
        window.location.href = url;
      },
      children: ctaCopy
    });
  }
  const productApiName = (_banner$productApiNam = banner.productApiNames) === null || _banner$productApiNam === void 0 ? void 0 : _banner$productApiNam[0];
  if (!cta.type || typeof productApiName !== 'string') return undefined;
  const purchaseMotion = isPublicPurchaseMotion(cta.type) ? cta.type : undefined;
  if (!purchaseMotion) return undefined;
  return /*#__PURE__*/_jsx(PublicPurchaseMotionCTAWrapper, {
    purchaseMotion: purchaseMotion,
    productApiName: productApiName,
    displayIndex: 1,
    currencyCode: currencyCode,
    paymentTerm: "ANNUAL",
    commitmentTerm: "ANNUAL",
    trackingData: {
      app: 'pricing-pages',
      source: TRACKING_SOURCES.BANNER,
      screen,
      uniqueId: `pricing-banner-${String(banner.bannerName)}-${productApiName}`
    },
    uiButtonProps: {
      use: 'tertiary',
      size: 'small',
      block: false
    },
    children: ctaCopy
  });
}
export function usePublicBannerForPage(productGroupsData, screen) {
  var _productGroupsData$ba;
  const {
    countryCode,
    displayedCurrencyCode
  } = useCurrency();
  const rawBanners = (_productGroupsData$ba = productGroupsData === null || productGroupsData === void 0 ? void 0 : productGroupsData.banners) !== null && _productGroupsData$ba !== void 0 ? _productGroupsData$ba : EMPTY_BANNERS;
  const {
    banners,
    dismissBanner
  } = useDynamicBanners(rawBanners);
  const shouldShowRussianBlockedBanner = countryCode === 'RU';
  const bannersWithCTA = useMemo(() => banners.map(banner => ({
    banner,
    purchaseMotionCTA: buildCTA(banner, screen, displayedCurrencyCode)
  })), [banners, screen, displayedCurrencyCode]);
  const hasBanner = shouldShowRussianBlockedBanner || banners.length > 0;
  return {
    hasBanner,
    bannerProps: {
      countryCode: typeof countryCode === 'string' ? countryCode : undefined,
      banners: bannersWithCTA,
      onDismissBanner: dismissBanner,
      screen
    }
  };
}